export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_08.cc24f82d.jpg";